export const doc_subscriptions_en = {
  title: "Subscriptions",
  home_title: "How subscriptions work",
  description: `To keep Piper up to date and free of advertisements we rely on our purchases and subscription systems. Users can use our app for free with certain limitations and can opt to subscribe using one of our available plans to support the app and access new functionalities.
  
  You can choose from these 3 plans we have available:
  
  `,
  free_plan: "Free plan: ",
  free_plan_description: `The free plan allows you to continue using Piper normally, but you won't have access to the additional features of other subscription plans.
  
  `,
  collector_plan: "Collector plan: ",
  collector_plan_description: `This plan does not include any additional features for now. With the 'Collector' subscription, you will be helping Piper grow and remain ad-free. This subscription does not have the benefits of the 'Premium' subscription.

Pay once per month. Cancel at any time.
  
  `,
  premium_plan: "Premium plan: ",
  premium_plan_description: `The 'Premium' subscription unlocks the following features:
  
  `,
  premium_plan_body_1: "Upload additional images for your albums using the image gallery.",
  premium_plan_body_2: `Use images from Discogs when importing albums.
  
  `,
  premium_plan_end: "Pay once per month. Cancel at any time.",
  access: `
  
To access the status of your current subscription or purchase another one, you can go to your user profile.
  
`
};
